var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view"},[_c('Header'),_c('Banner'),_c('card-content'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }